import { loadThemeStyles } from '../services/themeStylesService';
import {
    loadFonts,
    buildFontFaceCss,
    buildFontVariablesCss,
    buildFontWeightCss,
    registerFontsInStyleManager,
} from '../services/fontsService';
import { imageCaptionCanvasStyles } from '../blocks/bootstrap-components/components/imageCaption';

export const loadCanvasCss = async ({ editor, website }) => {
    const canvasStyles = `
                html {
                    --gjs-primary-color: #18181b;
                }
                a {
                    color: #c45453;
                    text-decoration: none;
                }

                ul,
                ol {
                    list-style-type: disc;
                    padding-left: 20px;
                    margin: 12px 0;
                }

                ul li,
                ol li {
                    display: list-item;
                    padding: 2px 0;
                }

                ol {
                    list-style-type: decimal;
                }

                .gjs-dashed .container,
                .gjs-dashed .container-fluid,
                .gjs-dashed .row,
                .gjs-dashed .col,
                .gjs-dashed [class^="col-"] {
                    min-height: 1.5rem !important;
                }

                .gjs-dashed .w-100 {
                    min-height: 0.25rem !important;
                    background-color: rgba(0, 0, 0, 0.1);
                }

                .gjs-dashed img {
                    min-width: 25px;
                    min-height: 25px;
                    background-color: rgba(0, 0, 0, 0.5);
                }

                .gjs-row {
                    display: table;
                    padding: 10px;
                    width: 100%;
                }

                .gjs-selected {
                    outline: 2px solid #3b97e3 !important;
                    outline-offset: -2px;
                }

                .sio-text.gjs-selected {
                    padding-left: 5px;
                    padding-right: 5px;
                }

                .gjs-dashed .btn-group,
                .gjs-dashed .btn-toolbar {
                    padding-right: 1.5rem !important;
                    min-height: 1.5rem !important;
                }

                .gjs-dashed .card,
                .gjs-dashed .card-group,
                .gjs-dashed .card-deck,
                .gjs-dashed .card-columns {
                    min-height: 1.5rem !important;
                }

                .gjs-dashed .collapse {
                    display: block !important;
                    min-height: 1.5rem !important;
                }

                .gjs-dashed .dropdown {
                    display: block !important;
                    min-height: 1.5rem !important;
                }

                .gjs-dashed .dropdown-menu {
                    display: block !important;
                    min-height: 1.5rem !important;
                }

                .sio-field-wrapper {
                    min-height: 1.5rem;
                }

                .sio-landing-page-image {
                    min-height: 1.5rem;
                }

                .sio-teaser-wishlist-button {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    color: var(--primary);
                    cursor: default;
                    line-height: 0;
                }

                .sio-teaser-wishlist-button svg {
                    width: 20px;
                    height: 19px;
                }

                .sio-teaser-days-count {
                    display: inline-block;
                    min-height: 1.5rem;
                }
                .sio-teaser-level,
                .sio-teaser-category-select,
                .sio-teaser-country-select,
                .sio-teaser-cheapest-price,
                .sio-teaser-journey-date-select {
                    display: inline-block;
                    min-height: 1.5rem;
                }

                .sio-teaser-condition {
                    min-height: 1.5rem;
                }

                .swiper-slide:empty::before,
                .login-modal:empty::before,
                .sio-icon:empty::before,
                .sio-div:empty::before,
                .sio-field-wrapper:empty::before,
                .sio-landing-page-image:empty::before,
                .sio-teaser-days-count:empty::before,
                .sio-teaser-cheapest-price:empty::before,
                .sio-teaser-country-select:empty::before,
                .sio-teaser-category-select:empty::before,
                .sio-teaser-level:empty::before,
                .sio-teaser-journey-date-select:empty::before,
                .sio-teaser-condition:empty::before,
                .sio-jd-gallery:empty::before,
                .sio-jd-icons:empty::before,
                .sio-jd-location:empty::before,
                .sio-jd-date-and-price::before,
                .sio-jd-services::before,
                .sio-jd-days::before,
                .sio-jd-testimonial::before,
                .sio-jd-similar-tours::before,
                .sio-jd-variant-switcher::before,
                .sio-jd-navigation-bar::before,
                .sio-jd-journey-booking::before,
                .sio-jd-breadcrumbs::before,
                .sio-jd-operation-manager::before,
                .sio-jd-videos::before,
                .sio-jd-ship::before,
                .hover-container:empty::before,
                .title-container:empty::before,
                .accordion-body:empty::before,
                [data-gjs-type="column"]:empty::before,
                [data-gjs-type="row"]:empty::before,
                .gjs-row [data-gjs-type="default"]:empty::before,
                [data-gjs-type="link-box"]:empty::before,
                .container:empty::before,
                [data-gjs-type="grid"]:empty::before,
                .sio-dynamic-cell:empty::before,
                [data-gjs-type="dynamic-cell"]:empty::before,
                .tabs-btn:empty::before,
                .tabs-panel:empty::before {
                    content: "Grid";
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-height: 30px;
                    height: 100%;
                    padding: 10px 16px;
                    background-color: #ddd;
                    color: #000;
                    font-size: 16px;
                    font-weight: bold;
                    opacity: 0.3;
                    border-radius: 3px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .hover-container:empty::before               { content: "Drop Content"; }
                .sio-icon:empty::before                      { content: "Icon"; }
                .sio-div:empty::before                       { content: "Div"; }
                .title-container:empty::before               { content: "Titel, Inhalte hierher ziehen"; }
                .sio-jd-gallery:empty::before,
                .sio-jd-icons:empty::before,
                .sio-jd-location:empty::before,
                .sio-jd-date-and-price:empty::before,
                .sio-jd-services:empty::before,
                .sio-jd-days:empty::before,
                .sio-jd-testimonial:empty::before,
                .sio-jd-similar-tours:empty::before,
                .sio-jd-variant-switcher:empty::before,
                .sio-jd-navigation-bar:empty::before,
                .sio-jd-journey-booking:empty::before,
                .sio-jd-breadcrumbs:empty::before,
                .sio-jd-operation-manager:empty::before,
                .sio-jd-videos:empty::before,
                .sio-jd-ship:empty::before,
                .sio-field-wrapper:empty::before,
                .sio-landing-page-image:empty::before,
                .sio-teaser-days-count:empty::before,
                .sio-teaser-cheapest-price:empty::before,
                .sio-teaser-category-select:empty::before,
                .sio-teaser-level:empty::before,
                .sio-teaser-country-select:empty::before,  
                .sio-teaser-journey-date-select:empty::before,
                .sio-teaser-condition:empty::before { content: attr(data-field-label); }
                .container:empty::before                     { content: "Container"; }
                .accordion-body:empty::before                { content: "Accordion Body, Drop Components here"; }
                .tabs-btn:empty::before                      { content: "Tab Button"; }
                .tabs-panel:empty::before                    { content: "Tab Panel"; }

                .gjs-row [data-gjs-type="default"]:empty::before  { content: "Column"; }
                [data-gjs-type="row"]:empty::before               { content: "Flex Row"; }
                [data-gjs-type="column"]:empty::before            { content: "Flex Column"; }
                .sio-dynamic-cell:empty::before,
                [data-gjs-type="dynamic-cell"]:empty::before     { content: "Spalte"; }
                [data-gjs-type="link-box"]:empty::before          { content: "Link Box"; }
                [data-gjs-type="login-modal"]:empty::before       { content: "Login Modal Opener"; }
                [data-gjs-type="blogsList"]:empty::before {
                    content: "Blogs List";
                    width: 90%;
                    margin: auto;
                    min-height: 160px;
                }

                .swiper-slide {
                    min-height: 160px;
                }

                .swiper-slide:empty {
                    min-height: 360px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                }

                .swiper-slide:empty::before {
                    content: "Inhalt hier einfügen";
                    width: 100%;
                }

                .sio-swiper-editor-topbar {
                    position: fixed;
                    z-index: 9999;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    gap: 12px;
                    min-height: 44px;
                    min-width: 0;
                    max-width: calc(100vw - 24px);
                    padding: 0 12px;
                    background: #1a1a1b;
                    border-radius: 12px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
                    box-sizing: border-box;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "SF Pro", sans-serif;
                    font-size: 14px;
                    font-weight: 500;
                    user-select: none;
                    overflow: hidden;
                }

                .sio-swiper-editor-topbar__pagination {
                    display: flex;
                    align-items: center;
                    gap: 2px;
                    flex: 1 1 0%;
                    min-width: 0;
                    max-width: 100%;
                    overflow: hidden;
                    background: rgba(255, 255, 255, 0.06);
                    border-radius: 10px;
                    padding: 4px 6px;
                }

                .sio-swiper-editor-topbar__numbers {
                    display: flex;
                    align-items: center;
                    gap: 2px;
                    flex: 1 1 0%;
                    min-width: 0;
                    overflow-x: auto;
                    scrollbar-width: none;
                }

                .sio-swiper-editor-topbar__numbers::-webkit-scrollbar {
                    display: none;
                }

                .sio-swiper-editor-topbar__status {
                    flex: 0 1 auto;
                    min-width: 0;
                    color: rgba(255, 255, 255, 0.7);
                    font-size: 13px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .sio-swiper-editor-topbar__actions {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    flex: 0 0 auto;
                    flex-shrink: 0;
                    margin-left: auto;
                }

                .sio-swiper-editor-topbar__btn {
                    border: 0;
                    background: transparent;
                    color: rgba(255, 255, 255, 0.85);
                    min-width: 36px;
                    width: 36px;
                    height: 36px;
                    padding: 0;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 10px;
                    cursor: pointer;
                    transition: background 0.15s ease, color 0.15s ease;
                }

                .sio-swiper-editor-topbar__btn:hover {
                    background: rgba(255, 255, 255, 0.12);
                    color: #fff;
                }

                .sio-swiper-editor-topbar__btn svg {
                    width: 18px;
                    height: 18px;
                    stroke-width: 2;
                }

                .sio-swiper-editor-topbar__btn--arrow,
                .sio-swiper-editor-topbar__btn--move,
                .sio-swiper-editor-topbar__btn--control {
                    flex-shrink: 0;
                }

                .sio-swiper-editor-topbar__btn--arrow svg,
                .sio-swiper-editor-topbar__btn--move svg,
                .sio-swiper-editor-topbar__btn--control svg {
                    width: 18px;
                    height: 18px;
                }

                .sio-swiper-editor-topbar__btn--number {
                    min-width: 32px;
                    width: auto;
                    flex-shrink: 0;
                    padding: 0 8px;
                    font-size: 13px;
                }

                .sio-swiper-editor-topbar__btn--number:hover {
                    background: rgba(255, 255, 255, 0.1);
                }

                .sio-swiper-editor-topbar__btn--active,
                .sio-swiper-editor-topbar__btn--active:hover {
                    background: rgba(255, 255, 255, 0.18);
                    color: #fff;
                    text-decoration: underline;
                    text-underline-offset: 3px;
                }

                .sio-swiper-editor-topbar__btn--disabled,
                .sio-swiper-editor-topbar__btn--disabled:hover {
                    color: rgba(255, 255, 255, 0.35);
                    background: transparent;
                    cursor: not-allowed;
                }

                .acc-collapse {
                    display: block;
                    height: 0;
                    overflow: hidden;
                    transition: max-height 0.3s ease;
                }

                .acc-collapse.acc-show {
                    height: 100%;
                }

                .accordion .card-header[aria-expanded="true"] .accordion-icon {
                    transform: rotate(180deg);
                }

                .cms-breadcrumbs {
                    --separator: ">";
                }

                .cms-breadcrumbs > :not([hidden]) ~ :not([hidden]) {
                    margin-left: 0.5rem;
                }

                .cms-breadcrumbs__li:not(:last-child)::after {
                    content: var(--separator);
                    margin-left: 0.5rem;
                }

                .cms-breadcrumbs__item {
                    color: black !important;
                }

                @media (max-width: 768px) {
                .cms-breadcrumbs__ol {
                    font-size: 12px;
                }

                .cms-breadcrumbs__li:not(:last-child)::after {
                    margin: 0 0.25rem;
                }
                }

                .gallery-item:empty {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    background-color: #ddd;
                    color: #000;
                    opacity: 0.3;
                }

                .gallery-item:empty::before {
                    content: "Gallery Item";
                    font-weight: bold;
                }

                ${imageCaptionCanvasStyles}

    `;

    try {
        const themeStyles = await loadThemeStyles({ website });
        const getAllfonts = await loadFonts({ website });
        const { fonts } = getAllfonts || {};

        const fontVariables = buildFontVariablesCss({ fonts });
        const fontWeightCSS = buildFontWeightCss({ fonts });

        const combinedStyles = `
                ${themeStyles}
                ${canvasStyles}
                ${fontVariables}
                ${fontWeightCSS}

`;
        if (!editor.Config) {
            editor.Config = {};
        }

        editor.Config.canvasCss =
            (editor.Config.canvasCss || '') + combinedStyles;

        const fontFaceCSS = await buildFontFaceCss({ fonts, website });


        const upsertStyle = (doc, id, css) => {
            if (!doc || !doc.head || !css) return;
            let styleEl = doc.getElementById(id);
            if (!styleEl) {
                styleEl = doc.createElement('style');
                styleEl.id = id;
                doc.head.appendChild(styleEl);
            }
            if (styleEl.innerHTML !== css) {
                styleEl.innerHTML = css;
            }
        };

        const applyStylesToCanvas = () => {
            try {
                const canvasDoc = editor.Canvas.getDocument();
                upsertStyle(canvasDoc, 'sio-font-faces', fontFaceCSS);
                upsertStyle(canvasDoc, 'sio-theme-styles', combinedStyles);
            } catch (err) {
            }
        };

        upsertStyle(document, 'sio-font-faces', fontFaceCSS);
        applyStylesToCanvas();
        editor.on('canvas:frame:load', applyStylesToCanvas);
        editor.on('load', applyStylesToCanvas);
        registerFontsInStyleManager({ editor, fonts });
    } catch (error) {
        console.error('Error loading canvas CSS:', error);
    }
};
